import React from 'react';

const UsersTable = ({ 
  users, 
  currentUser, 
  processingUserId, 
  onToggleUserStatus,
  onManageQuota,
  onShowPendingModal,
  onViewDocumentTypes,
  formatDate,
  getRoleBadge,
  getStatusBadge
}) => {
  return (
    <div className="card shadow-sm users-table">
      <div className="card-header bg-light">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="card-title mb-0">
            <i className="bi bi-table me-2 text-primary"></i>
            Lista de Usuarios
          </h5>
          <small className="text-muted">
            {users.length === 1 ? '1 usuario encontrado' : `${users.length} usuarios encontrados`}
          </small>
        </div>
      </div>
      
      <div className="table-responsive">
        <table className="table table-hover mb-0">
          <thead className="table-light">
            <tr>
              <th>Usuario</th>
              <th>Rol</th>
              <th>Estado</th>
              <th>Cuota</th>
              <th>Fecha de Registro</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-5">
                  <div className="no-users-message">
                    <i className="bi bi-search fs-1 d-block mb-3"></i>
                    <h6 className="mb-2">No se encontraron usuarios</h6>
                    <p className="mb-0">No hay usuarios que coincidan con los filtros aplicados</p>
                    <small className="text-muted">
                      Intenta ajustar los criterios de búsqueda o filtrado
                    </small>
                  </div>
                </td>
              </tr>
            ) : (
              users.map((userData) => (
              <tr key={userData.id}>
                <td>
                  <div>
                    <div className="fw-bold">{userData.full_name}</div>
                    <div className="text-muted small">{userData.email}</div>
                  </div>
                </td>
                <td>{getRoleBadge(userData.role)}</td>
                <td>{getStatusBadge(userData.is_active)}</td>
                <td>
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center mb-1">
                      <small className="text-muted me-1">Usados:</small>
                      <span className="badge bg-primary">{userData.quota?.documents_used || 0}</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <small className="text-muted me-1">Disponibles:</small>
                      <span className={`badge ${
                        (userData.quota?.available_documents || 0) < 10 
                          ? 'bg-danger' 
                          : (userData.quota?.available_documents || 0) < 50 
                            ? 'bg-warning' 
                            : 'bg-success'
                      }`}>
                        {userData.quota?.available_documents || 0}
                      </span>
                    </div>
                  </div>
                </td>
                <td className="text-muted small">{formatDate(userData.created_at)}</td>
                <td>
                  <div className="d-flex gap-1">

                    {/* Botón para aprobar solicitud de cuota */}
                    {userData.pending_quota_request && userData.pending_quota_request.length > 0 && (
                      <button
                        onClick={() => onShowPendingModal(userData)}
                        className="btn btn-sm btn-warning"
                        title="Aprobar solicitudes de cuota"
                        style={{ minWidth: '32px' }}
                      >
                        <i className="bi bi-check2-circle"></i>
                      </button>
                    )}

                    {/* Botón para gestionar cuota */}
                    <button
                      onClick={() => onManageQuota(userData)}
                      className="btn btn-sm btn-outline-primary"
                      title="Gestionar cuota"
                      style={{ minWidth: '32px' }}
                    >
                      <i className="bi bi-wallet2"></i>
                    </button>

                    {/* Botón para ver tipos de documentos */}
                    <button
                      onClick={() => onViewDocumentTypes(userData)}
                      className="btn btn-sm btn-outline-info"
                      title="Ver tipos de documentos"
                      style={{ minWidth: '32px' }}
                    >
                      <i className="bi bi-file-earmark-text"></i>
                    </button>
                 

                    {/* Botón para activar/desactivar usuario */}
                    {userData.id !== currentUser?.id ? (
                      <button
                        onClick={() => onToggleUserStatus(userData.id, userData.is_active)}
                        disabled={processingUserId === userData.id}
                        className={`btn btn-sm ${
                          userData.is_active
                            ? 'btn-outline-danger'
                            : 'btn-outline-success'
                        }`}
                        title={userData.is_active ? 'Desactivar usuario' : 'Activar usuario'}
                        style={{ minWidth: '32px' }}
                      >
                        {processingUserId === userData.id ? (
                          <span className="spinner-border spinner-border-sm"></span>
                        ) : (
                          <i className={`bi ${userData.is_active ? 'bi-x-circle' : 'bi-check-circle'}`}></i>
                        )}
                      </button>
                    ) : (
                      <button
                        onClick={() => onManageQuota(userData)}
                        className="btn btn-sm btn-success"
                        title="Gestionar mi cuota"
                        style={{ minWidth: '32px' }}
                      >
                        <i className="bi bi-person-gear"></i>
                      </button>
                    )}
                  </div>
                </td>
              </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UsersTable;
